const hasCodeToken = (item, token) =>
  String(item?.code || "")
    .toUpperCase()
    .includes(token);

const hasExactCode = (item, code) =>
  String(item?.code || "")
    .trim()
    .toUpperCase() === code;

export const filterPolicyConditionOptions = (items = []) =>
  items.filter(
    (item) => hasCodeToken(item, "RECIPIENT") || hasCodeToken(item, "DATETIME"),
  );

export const filterPolicyActionOptions = (items = []) =>
  items.filter((item) => hasExactCode(item, "USE"));

export const filterPolicyRecipientOperatorOptions = (items = []) =>
  items.filter((item) => hasExactCode(item, "EQ"));

export const isPolicyRecipientCondition = (
  selectedValue,
  items = [],
) => {
  const normalizedValue = String(selectedValue || "").trim().toUpperCase();

  if (normalizedValue.includes("RECIPIENT")) return true;

  return items.some(
    (item) =>
      item?.concept_iri === selectedValue && hasExactCode(item, "RECIPIENT"),
  );
};

export const isPolicyDatetimeCondition = (
  selectedValue,
  items = [],
) => {
  const normalizedValue = String(selectedValue || "").trim().toUpperCase();

  if (normalizedValue.includes("DATETIME")) return true;

  return items.some(
    (item) =>
      item?.concept_iri === selectedValue && hasExactCode(item, "DATETIME"),
  );
};

const pad = (value) => String(value).padStart(2, "0");

const formatOffset = (date) => {
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const absolute = Math.abs(offsetMinutes);
  const hours = pad(Math.floor(absolute / 60));
  const minutes = pad(absolute % 60);
  return `${sign}${hours}:${minutes}`;
};

export const formatPolicyDatetimeValue = (dateValue) => {
  if (!dateValue) return "";

  const localDate = new Date(`${dateValue}T00:00:00`);
  if (Number.isNaN(localDate.getTime())) return "";

  return `${dateValue}T00:00:00${formatOffset(localDate)}`;
};

export const parsePolicyDatetimeForInput = (value) => {
  if (!value) return "";
  const raw = String(value);
  const [datePart] = raw.split("T");
  return /^\d{4}-\d{2}-\d{2}$/.test(datePart) ? datePart : "";
};
